module.exports = __webpack_public_path__ + "img/logo-loslibertadores.b045231a.png";